import React from 'react';
import { ArrowRight, ExternalLink, ShieldCheck, Store } from 'lucide-react';
import amanyaMarketplace from '../assets/amanya-marketplace-home.png';
import docmanyaMedical from '../assets/docmanya-medical-landscape.png';

export default function DocManyaSection() {
  return (
    <section className="mce-digital-projects digital-docmanya-section">
      <div className="mce-about-container">
        <header className="mce-digital-projects-heading">
          <h2><span>Des solutions numériques</span><span>pensées pour des usages concrets.</span></h2>
          <p>Deux plateformes, deux secteurs et une même ambition : simplifier les échanges et créer de la valeur.</p>
        </header>

        <div className="mce-digital-projects-grid">
          <article className="mce-digital-project-card docmanya-project-card">
            <div className="docmanya-medical-visual" aria-hidden="true">
              <img src={docmanyaMedical} alt="" />
              <span><ShieldCheck /> Données organisées et sécurisées</span>
            </div>
            <div className="mce-project-card-copy">
              <div className="docmanya-title-row"><h3>DocManya</h3><i>Bientôt disponible</i></div>
              <p>Une solution médicale conçue pour centraliser les dossiers, fluidifier le suivi et faciliter l’accès aux informations utiles.</p>
              <span className="mce-project-status">Projet en développement</span>
            </div>
          </article>

          <article className="mce-digital-project-card amanya-project-card">
            <a
              className="amanya-project-visual"
              href="https://amanya-distribution.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Découvrir la marketplace Amanya"
            >
              <img src={amanyaMarketplace} alt="Page d’accueil de la marketplace Amanya" />
              <span><ExternalLink /> Voir la plateforme</span>
            </a>
            <div className="mce-project-card-copy">
              <div className="mce-project-card-topline">
                <span><Store /> Marketplace partenaires</span>
              </div>
              <h3>Amanya</h3>
              <p>La marketplace dédiée aux partenaires de MCE pour présenter, vendre et développer leurs offres sur une plateforme commune.</p>
              <a className="amanya-project-link" href="https://amanya-distribution.com/" target="_blank" rel="noopener noreferrer">
                Explorer Amanya <ArrowRight />
              </a>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
